/**
 * Shopify Cart Button Language Translator
 * 
 * This script observes dynamically injected cart buttons and translates their text
 * based on a language configuration object.
 */

// Language translations configuration
const translations = {
  en: {},
  fr: {
    "Sold Out": "Épuisé",
    "Add to Cart": "Ajouter au panier",
    "Add To Cart": "Ajouter au panier",
    "Pre-order!": "Précommander !",
    "Confirm Pre-order": "Confirmer la précommande",
    "Only {num} left!": "Plus que {num} restant !",
    // Yotpo elements
    "Customer Reviews": "Avis des clients",
    "{num} Reviews": "{num} Avis",
    "Based on {num} reviews": "Sur la base de {num} avis",
    "Score of {num} out of {num} stars": "Note de {num} sur {num} étoiles",
    "We found {num} matching reviews.": "Nous avons trouvé {num} avis correspondants.",
    "Clear filters": "Nettoyer les filtres",
    "Write A Review": "Écrire un avis",
    "Search reviews": "Rechercher des avis",
    "Rating": "Notation",
    "With media": "Avec médias",
    "All ratings": "Toutes les notations",
    "Sort by:": "Trier par:",
    "Most relevant": "Le plus pertinent",
    "Most recent": "Le plus récent",
    "Verified purchase": "Achat vérifié",
    "Highest rating": "Note la plus élevée",
    "Lowest rating": "Note la plus basse",
    "Was this review helpful?": "Cet avis a-t-il été utile ?",
    "See reviews summary": "Voir le résumé des avis",
    // Kiwi elements
    "Size Chart": "Guide des tailles",
    "What's my size?": "Quelle est ma taille\u00A0?",
    "Size Charts": "Guides des tailles",
    "Calculate My Size": "Calculer ma taille",
    "Size Chart": "Tableau des tailles",
    "Privacy": "Confidentialité",
    "Chest Girth": "Tour de poitrine",
    "Recommended Weight": "Poids recommandé",
    "We recommend the size:": "Nous recommandons la taille :",
    "We couldn't find a good match": "Nous n'avons pas trouvé de correspondance",
    "Tight": "Serré",
    "Loose": "Ample",
    "Measure around the largest part of your dog's chest, justbehind their forelimbs.": "Mesurez autour de la partie la plus large de la poitrine de votre chien, juste derrière les pattes avant.",
    "Size Guide": "Guide des tailles",
    "Size By Breed": "Taille par race",
    "SIZE": "TAILLE",
    "Size": "Taille",
    "Breed": "Race",
    "Small": "Petit",
    "Medium": "Moyen",
    "Large": "Grand",
    // Unit Labels
    "inches": "pouces",
    "lbs": "livres",

    // New Field Labels
    "Paw Width": "Largeur de la patte",
    "Paw Length": "Longueur de la patte",
    "Back Length": "Longueur du dos",
    "Dog Weight": "Poids du chien",
    "Neck Circumference": "Tour de cou",
    "Hand Length": "Longueur de la main",

    // New Help Text
    "Type in your dog's exact paw measurements (ex. 2.5 inches)": "Indiquez les mesures exactes de la patte de votre chien (ex. 2,5 pouces)",
    "Measure from the base of your dog’s neck (right below wheretheir collar would sit) all the way to just above the top of their tail.": "Mesurez depuis la base du cou de votre chien (juste en dessous de l'endroit où se trouverait son collier) jusqu'à juste au-dessus de la base de sa queue.",

    // New Instructional Paragraphs
    "Find your dog's boot size: Print out": "Trouvez la taille de bottes de votre chien : Imprimer\u00A0",
    "Find your dog's boot size:": "Trouvez la taille de bottes de votre chien :\u00A0",
    "this": "ce",
    "chart to help measure their paws.": "\u00A0tableau pour vous aider à mesurer leurs pattes.",
    "Confirm your dog's weight to determine which Weighted Calm™size will be best for their comfort and wellbeing.": "Confirmez le poids de votre chien pour déterminer quelle taille de Weighted Calm™ conviendra le mieux à son confort et à son bien-être.",
    "Toy weight was calculated to be comfortable for your dog to pick up with their mouth. If your dog is in between sizes or fits multiple sizes, we recommend sizing down.": "Le poids du jouet a été calculé pour être confortable à transporter dans la bouche de votre chien. Si votre chien est entre deux tailles ou correspond à plusieurs tailles, nous recommandons de choisir la plus petite.",
    "With your dog standing or sitting, measure around theirneck.": "Avec votre chien debout ou assis, mesurez autour de son cou.",
    "The weight was calculated to not exceed 3% of your dog's body weight. If your dog is in between sizes, we recommend sizing down.": "Le poids a été calculé pour ne pas dépasser 3 % du poids corporel de votre chien. Si votre chien est entre deux tailles, nous recommandons de choisir la taille inférieure.",
    "Blanket Weight": "Poids de la couverture",
    "The weight was calculated to not exceed 10% of your dog's body weight. If your dog is in between sizes or fits multiple sizes, we recommend sizing down.": "Le poids a été calculé pour ne pas dépasser 10 % du poids corporel de votre chien. Si votre chien est entre deux tailles ou correspond à plusieurs tailles, nous recommandons de choisir la plus petite.",

    "Toy Weight": "Poids du jouet",
    "Insert Weight": "Insérer le poids",
    "Leg Length": "Longueur de la jambe",
    "Paw Length & Width": "Longueur et largeur de la patte",
    "With your dog's paw flat to the ground, measure their paw from their nail to where the paw is no longer touching the ground. Then measure their paw from edge to edge.": "Avec la patte de votre chien bien à plat sur le sol, mesurez-la depuis l'ongle jusqu'à l'endroit où elle ne touche plus le sol. Ensuite, mesurez la patte d'un bord à l'autre.",
    "With your dog's paw flat to the ground, measure their paw from their nail to where they are no longer touching the ground.": "Avec la patte de votre chien à plat au sol, mesurez de l'ongle jusqu'à l'endroit où ils ne touchent plus le sol.",
    "With your dog's paw flat to the ground, measure their paw from edge to edge.": "Avec la patte de votre chien à plat sur le sol, mesurez sa patte d'un bord à l'autre.",
    "With your dog standing and all paws on the ground, measure their leg length as indicated. Boot sizes are available in Regular and Short leg lengths to ensure a comfortable fit.": "Avec votre chien debout et toutes les pattes au sol, mesurez la longueur de leur jambe comme indiqué. Les tailles de bottes sont disponibles en longueurs de jambe régulières et courtes pour assurer un ajustement confortable.",
    "Boot sizes are available for REGULAR and SHORT leg lengths. Please measure your dog's paw size and see our breed recommendations below to ensure best fit.": "Les tailles de bottes sont disponibles pour des longueurs de jambe RÉGULIÈRES et COURTES. Veuillez mesurer la taille de la patte de votre chien et consulter nos recommandations par race ci-dessous pour garantir le meilleur ajustement.",
    "For dogs with long backs such as Corgis and Dachshunds, we recommend our Soft Shield Boots instead of the": "Pour les chiens au dos long comme les Corgis et les Teckels, nous recommandons nos bottes Soft Shield au lieu des",
    "Suspender": "à bretelles",
    "Boots SHORT sizing.": "bottes SHORT.",
    "Recommended Breeds": "Races recommandées",
    "Head Circumference": "Tour de tête",
    "Begin on top of the head and measure under your dog's chin.": "Commencez sur le dessus de la tête et mesurez sous le menton de votre chien.",
    "Size {num}-{num}": "Taille {num}-{num}",
    // Badges
    "New!": "Nouveau !", 
    "New Variant!": "Nouveau !", 
    "Final Sale!": "Vente finale ",
    "Final Sale Variant!": "Vente finale ",
    "Last Chance Variant!": "Dernière chance !", 
    "Last Chance!": "Dernière chance !",
    "Best Seller!": "Meilleure vente !",
    // Store locator
    "Search": "Recherche",
    "Select All": "Tout sélectionner",
    "Filter": "Filtrer",
    "Please enter your address and city": "Veuillez entrer votre adresse et votre ville",
    "View On Map": "Voir sur la carte",
    "Directions": "Itinéraires", 
    "Deselect All": "Tout désélectionner",

    // ——— Size abbreviations — French equivalents ———
    "XXS":    "TTP",      // Très très petit
    "XS":     "TP",       // Très petit
    "S":      "P",        // Petit
    "M":      "M",        // Moyen
    "L":      "G",        // Grand
    "XL":     "TG",       // Très grand
    "XXL":    "TTG",      // Très très grand
    "XXXL":   "TTTG",     // Trois fois très grand

// ——— Compound sizes (ranges) ———
    "XXS/XS":   "TTP/TP",
    "XS/S":     "TP/P",
    "S/M":      "P/M",
    "M/L":      "M/G",
    "L/XL":     "G/TG",
    "XL/XXL":   "TG/TTG",
    "XXL/XXXL": "TTG/TTTG",

    // Colors
  "Black": "Noir",
  "White": "Blanc",
  "Red": "Rouge",
  "Blue": "Bleu",
  "Green": "Vert",
  "Yellow": "Jaune",
  "Orange": "Orange",
  "Pink": "Rose",
  "Purple": "Violet",
  "Brown": "Marron",
  "Grey": "Gris",
  "Gray": "Gris",
  "Beige": "Beige",
  "Navy": "Bleu marine",
  "Light Blue": "Bleu clair",
  "Dark Blue": "Bleu foncé",
  "Light Green": "Vert clair",
  "Dark Green": "Vert foncé",
  "Light Pink": "Rose clair",
  "Dark Pink": "Rose foncé",
  "Gold": "Doré",
  "Silver": "Argenté",
  "Burgundy": "Bordeaux",
  "Turquoise": "Turquoise",
  "Teal": "Sarcelle",
  "Coral": "Corail",
  "Lavender": "Lavande",
  "Ivory": "Ivoire",
  "Charcoal": "Charbon",
  "Mint": "Menthe",
  "Peach": "Pêche",
  "Mustard": "Moutarde",
  "Khaki": "Kaki",
  "Camel": "Camel",
  "Copper": "Cuivré",
  "Champagne": "Champagne",
  "Rainbow": "Arc-en-ciel",
  "Multicolor": "Multicolore",
  "Multi-color": "Multicolore",
  "Pastel": "Pastel",

  // Collection
  "For Your Pooch": "Pour votre toutou",
  },
  // Add more languages as needed
};

const breedTranslations = {
  "Shih-tzu": "Shih-tzu",
  "Bichon-frise": "Bichon frisé",
  "Maltese": "Bichon maltais",
  "Cavapoo": "Cavapoo",
  "Mini Shnauzer": "Mini Schnauzer",
  "Boston Terrier": "Boston Terrier",
  "Pug": "Carlin",
  "Cairn Terrier": "Cairn Terrier",
  "French Bulldog": "Bouledogue français",
  "Mini Bullterrier": "Mini Bullterrier",
  "Whippet": "Whippet",
  "Wheaten Terrier": "Wheaten Terrier",
  "Airedale Terrier": "Airedale Terrier",
  "Viszla": "Vizsla",
  "Portuguese Water Dog": "Chien d'eau portugais",
  "English Bulldog": "Bouledogue anglais",
  "German Shepherd": "Berger allemand",
  "Labrador Retriever": "Labrador Retriever",
  "Bernese Mountain Dog": "Bouvier bernois",
  "Bernedoodle": "Bernedoodle",
  "Doberman": "Doberman",
  "Chihuahua": "Chihuahua",
  "Teacup (Yorkie, Maltipoo)": "Teacup (Yorkshire Terrier, Maltipoo)",
  "Toy (Shih Tzu, Mini Poodle, Bichon Frise, Dachshund)": "Petit (Shih Tzu, Caniche miniature, Bichon frisé, Teckel)",
  "Spaniels (Cocker Spaniel, King Charles Spaniel)": "Épagneuls (Cocker Spaniel, King Charles Spaniel)",
  "Pugs, Frenchies, Terriers": "Carlin, Bouledogues français, Terriers",
  "Small Hound (Beagle, Whippet)": "Petit chien de chasse (Beagle, Whippet)",
  "Mini Doodle Mix (Mini Golden Doodle, Mini Labradoodle)": "Mélange Mini Doodle (Mini Golden Doodle, Mini Labradoodle)",
  "Wheaten Terrier & Corgi": "Wheaten Terrier et Corgi",
  "Doodle Mix (Labradoodle, Goldendoodle)": "Mélange Doodle (Labradoodle, Goldendoodle)",
  "Golden Retriever & Labs": "Golden Retriever et Labradors",
  "Great Dane & St. Bernard": "Grand Danois et Saint-Bernard",
  "Labs & Retrievers": "Labradors et Retrievers"
};

/**
 * Class to handle button text translation
 */
class ShopifyTranslator {
  constructor(options = {}) {
    this.options = Object.assign({
      language: 'en', // Default language
      buttonSelector: '.add-to-cart-button', // Default selector
      observeContainer: document.body, // Default container to observe
      translationMap: translations, // Default translations
      onTranslate: null // Optional callback after translation
    }, options);
    
    this.currentLanguage = this.options.language;
    this.observedElements = new Map();
    this.observer = null;

    this.init();
  }
  
  /**
   * Initialize the observer
   */
  init() {
    // Create mutation observer
    this.observer = new MutationObserver(this.handleMutations.bind(this));
    
    // Start observing
    this.observer.observe(this.options.observeContainer, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true
    });
    
    // Initial check for existing elements
    this.checkForElements();
  }
  
  /**
   * Handle DOM mutations
   */
  handleMutations(mutations) {
    let needsCheck = false;
    
    for (let mutation of mutations) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        needsCheck = true;
        break;
      }
    }
    
    if (needsCheck) {
      this.checkForElements();
    }
  }

  /**
   * Find and process elements matching the selector
   */
  checkForElements() {
    const buttons = document.querySelectorAll(this.options.buttonSelector);
    
    buttons.forEach(button => {
      // Only process buttons we haven't seen before or that have changed
      const buttonId = button.dataset.translatorId || this.generateId();
      
      if (!button.dataset.translatorId) {
        button.dataset.translatorId = buttonId;
        this.observedElements.set(buttonId, {
          element: button,
          originalText: button.textContent.trim()
        });
        this.translateElement(button);
      } else if (this.observedElements.has(buttonId) && 
                this.observedElements.get(buttonId).originalText !== button.textContent.trim()) {
        // Text has changed, update our record and translate
        this.observedElements.get(buttonId).originalText = button.textContent.trim();
        this.translateElement(button);
      }
    });
  }
  
  /**
   * Generate a unique ID for tracking elements
   */
  generateId() {
    return 'translator-' + Math.random().toString(36).substr(2, 9);
  }
  
  /**
   * Translate an element's text or placeholder
   */
  translateElement(element) {
    const originalText = element.textContent.trim();
    const buttonId = element.dataset.translatorId;

    // ——— Special case: Variant options like "Bleu / S", "Gris / L", etc. ———
if (
  (element.tagName === 'OPTION' &&
    element.parentElement?.id?.includes('product-select')) ||
  element.classList?.contains('custom-select__menu') ||
  element.parentElement?.classList?.contains('select-items')
) {
  // Match "Label / Size (optional trailing text)"
  const match = originalText.match(/^(.+?)\s*\/\s*([^\s(]+)(\s*\([^)]+\))?$/);

  if (match) {
    const [, labelPart, sizePart, trailingText = ''] = match;

    const labelKey = labelPart.trim(); // e.g. "Black"
    const sizeKey = sizePart.trim();   // e.g. "S/M"

    const translations = this.options.translationMap[this.currentLanguage] || {};
    const translatedLabel = translations[labelKey] || labelKey;
    const translatedSize = translations[sizeKey] || sizeKey;

    const newText = `${translatedLabel} / ${translatedSize}${trailingText}`;
    element.textContent = newText;

    if (this.options.onTranslate) {
      this.options.onTranslate(element, originalText, newText);
    }

    return; // done
  }
}
    // --- Special case: Small / Medium / Large size translations ---
    else if (element.classList.contains('ks-table-cell')) {
      const sizeTranslations = {
        "Small": this.options.translationMap[this.currentLanguage]["Small"],
        "Medium": this.options.translationMap[this.currentLanguage]["Medium"],
        "Large": this.options.translationMap[this.currentLanguage]["Large"]
      };
    
      // 1. First try: Direct size translation
      if (sizeTranslations[originalText]) {
        element.textContent = sizeTranslations[originalText];
        if (this.options.onTranslate) {
          this.options.onTranslate(element, originalText, element.textContent);
        }
        return;
      }
    
      // 2. Second try: Breed translation inside breed-related tables
      if (translateBreedsInElement(element)) {
        if (this.options.onTranslate) {
          this.options.onTranslate(element, originalText, element.textContent);
        }
        return;
      }
    }
    
    // Store original text if not already done
    if (!element.dataset.originalText) {
      element.dataset.originalText = originalText;
    }

    // Helper function to escape regex special characters
    const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // --- Special Case: INPUT Placeholders (non-submit) ---
    if (element.tagName === 'INPUT' && element.type !== 'submit' && element.hasAttribute('placeholder')) {
      const placeholderText = element.getAttribute('placeholder').trim();
      const knownPhrases = Object.keys(this.options.translationMap[this.currentLanguage]);
      
      // Check for an exact match
      for (const phrase of knownPhrases) {
        if (placeholderText === phrase) {
          element.setAttribute('placeholder', this.options.translationMap[this.currentLanguage][phrase]);
          if (this.options.onTranslate) {
            this.options.onTranslate(element, placeholderText, element.getAttribute('placeholder'));
          }
          return;
        }
      }
      
      // Check for keys containing {num}
      for (const phrase of knownPhrases) {
        if (phrase.includes('{num}')) {
          const parts = phrase.split('{num}');
          const regexPattern = '^' + parts.map(escapeRegex).join('(\\d+)') + '$';
          const regex = new RegExp(regexPattern, 'i');
          const match = placeholderText.match(regex);
          if (match) {
            const template = this.options.translationMap[this.currentLanguage][phrase];
            const groups = match.slice(1);
            let index = 0;
            const translatedText = template.replace(/{num}/g, () => groups[index++] || '');
            element.setAttribute('placeholder', translatedText);
            if (this.options.onTranslate) {
              this.options.onTranslate(element, placeholderText, translatedText);
            }
            return;
          }
        }
      }
    }
    
    // --- Special Case: INPUT type="submit" buttons (value attribute) ---
    if (element.tagName === 'INPUT' && element.type === 'submit') {
      const buttonValue = element.value.trim();
      const knownPhrases = Object.keys(this.options.translationMap[this.currentLanguage]);
      
      for (const phrase of knownPhrases) {
        if (buttonValue === phrase) {
          element.value = this.options.translationMap[this.currentLanguage][phrase];
          if (this.options.onTranslate) {
            this.options.onTranslate(element, buttonValue, element.value);
          }
          return;
        }
      }
      return;
    }
    
    // --- Special Case: OPTION elements with color/size format (handle placeholders) ---
    if (element.tagName === 'OPTION' && element.parentElement && 
        element.parentElement.id && element.parentElement.id.includes('product-select')) {
      const optionText = originalText;
      // Try to match "Color / suffix" pattern
      const colors = ['Black', 'Yellow', 'Pink'];
      
      for (const color of colors) {
        // Check if option text starts with color followed by ' / '
        const pattern = new RegExp(`^${color}\\s+\\/\\s+(.+)$`);
        const match = optionText.match(pattern);
        
        if (match) {
          // If we have a suffix placeholder translation for this color
          const placeholderKey = `${color} / {suffix}`;
          const placeholderTranslation = this.options.translationMap[this.currentLanguage][placeholderKey];
          
          if (placeholderTranslation) {
            // Replace {suffix} in the translation with the actual suffix
            const suffix = match[1];
            const translatedText = placeholderTranslation.replace('{suffix}', suffix);
            element.textContent = translatedText;
            if (this.options.onTranslate) {
              this.options.onTranslate(element, optionText, translatedText);
            }
            return;
          }
        }
      }
    }
    
    // --- Handle Generic Translations with {num} placeholders ---
    const knownPhrases = Object.keys(this.options.translationMap[this.currentLanguage]);
    for (const phrase of knownPhrases) {
      if (phrase.includes('{num}')) {
        const parts = phrase.split('{num}');
        const regexPattern = '^' + parts.map(escapeRegex).join('(\\d+)') + '$';
        const regex = new RegExp(regexPattern, 'i');
        const match = originalText.match(regex);
        if (match) {
          const template = this.options.translationMap[this.currentLanguage][phrase];
          const groups = match.slice(1);
          let index = 0;
          const translatedText = template.replace(/{num}/g, () => groups[index++] || '');
          element.textContent = translatedText;
          if (this.options.onTranslate) {
            this.options.onTranslate(element, originalText, translatedText);
          }
          return;
        }
      }
    }
    
    // --- Special Case: "Only X left!" handled separately (if not matched by the generic block) ---
    const quantityMatch = originalText.match(/Only\s+(\d+)\s+left!/i);
    if (quantityMatch) {
      const quantity = quantityMatch[1];
      const template = this.options.translationMap[this.currentLanguage]["Only {num} left!"];
      element.textContent = template.replace('{num}', quantity);
      if (this.options.onTranslate) {
        this.options.onTranslate(element, originalText, element.textContent);
      }
      return;
    }
    
    // --- Handle Direct Translations (exact text match) ---
    const lowerOriginal = originalText.toLowerCase();
    for (const phrase of knownPhrases) {
      if (phrase.toLowerCase() === lowerOriginal) {
        element.textContent = this.options.translationMap[this.currentLanguage][phrase];
        if (this.options.onTranslate) {
          this.options.onTranslate(element, originalText, element.textContent);
        }
        return;
      }
    }
    
    // --- Handle Partial Match for upsell texts (may contain product names) ---
    if (element.classList.contains('offer-text')) {
      for (const phrase of knownPhrases) {
        if (originalText.includes(phrase)) {
          const newText = originalText.replace(
            phrase, 
            this.options.translationMap[this.currentLanguage][phrase]
          );
          element.textContent = newText;
          if (this.options.onTranslate) {
            this.options.onTranslate(element, originalText, element.textContent);
          }
          return;
        }
      }
    }
  }
  
  /**
   * Change the current language
   */
  setLanguage(language) {
    if (this.options.translationMap[language]) {
      this.currentLanguage = language;
      
      // Retranslate all observed elements
      this.observedElements.forEach((data, id) => {
        const element = data.element;
        if (element) {
          this.translateElement(element);
        }
      });
      
      return true;
    }
    return false;
  }
  
  /**
   * Stop observing
   */
  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

function translateBreedsInElement(element) {
  let text = element.textContent.trim();

  const escapeRegex = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  for (const [english, french] of Object.entries(breedTranslations)) {
    const pattern = escapeRegex(english);
    const regex = new RegExp(pattern, 'g');
    text = text.replace(regex, french);
  }

  const hasChange = element.textContent.trim() !== text;
  if (hasChange) {
    element.textContent = text;
  }

  return hasChange;
}

// Usage example:
document.addEventListener('DOMContentLoaded', () => {
  // Detect language from URL path (e.g., domain.com/fr/)
  let currentLanguage = 'en'; // Default to English
  
  // Check if URL contains language code in the path
  const pathSegments = window.location.pathname.split('/').filter(segment => segment);
  if (pathSegments.length > 0) {
    const possibleLangCode = pathSegments[0];
    // Check if first path segment is a supported language code
    if (translations[possibleLangCode]) {
      currentLanguage = possibleLangCode;
    }
  }

  // Only apply to french site
  if (currentLanguage !== 'fr') return;
  
  // Initialize for main cart buttons
  const mainTranslator = new ShopifyTranslator({
    language: currentLanguage,
    buttonSelector: '[data-add-to-cart]', // Main cart buttons
    onTranslate: (element, before, after) => {
      // console.log(`Main button translated: "${before}" → "${after}"`);
    }
  });
  
  // Initialize for badges
  const badgeTranslator = new ShopifyTranslator({
    language: currentLanguage,
    buttonSelector: 'span.product__badge', // Badges
    onTranslate: (element, before, after) => {
      // console.log(`Badges translated: "${before}" → "${after}"`);
    }
  });

  // Initialize for yotpo elements (including search input placeholder)
  const yotpoTranslator = new ShopifyTranslator({
    language: currentLanguage,
    buttonSelector: '#yotpo-app .yotpo-headline, .yotpo-selected-value, .yotpo-dropdown-placeholder, .yotpo-dropdown-option, .yotpo-bottom-line-basic-text, .yotpo-bottom-line-text.sr-only, .yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel, .yotpo-score.yotpo-score-option, input.yotpo-search-input, .yotpo-review-votes-text, button.yotpo-new-review-btn, .yotpo-button-icon-text, .yotpo-matched-reviews, .yotpo-clear-filters',
    onTranslate: (element, before, after) => {
      // console.log(`Yotpo element translated: "${before}" → "${after}"`);
    }
  });

  // Initialize for kiwi elements
  const kiwiTranslator = new ShopifyTranslator({
    language: currentLanguage,
    buttonSelector: [
      '.ks-chart-modal-link ._ks_text',
      '.ks-calculator-container .postfix',
      '.ks-calculator-container ._ks_text',
      '.modal-title-sub-header', // Size Charts
      '.ks-modal-tab[data-tab="ks-calculator-tab-container"]', // Calculate My Size tab
      '.ks-calculator-header', // Calculate My Size header
      '.ks-modal-tab[data-tab="ks-chart-tab-container"]', // Size Chart tab
      '.ks-calculator-privacy-link span', // Privacy link
      '.element-label label span span', // Chest Girth, Recommended Weight labels
      '.element-help-text', // Field help text (NEW)
      '.ks-unit-toggle-label', // Unit toggle labels (NEW)
      '.formula-element .element-label span', // "We recommend the size"
      '.formula-text-no-result label', // "We couldn't find a good match"
      '.ks-calculator-line-title.left-title', // Tight
      '.ks-calculator-line-title.right-title', // Loose
      '.ks-html-content p', // Instruction text (GENERAL TEXT)
      '.ks-html-content p span', // Instruction text (GENERAL TEXT)
      '.ks-html-content p a span', // Links inside instruction paragraphs (NEW)
      '.ks-html-content p strong', // Bolded strong tags inside paragraphs (NEW)
      '.ks-table-content-wrapper .ks-table-header:first-of-type', // Size Guide
      '.ks-table-content-wrapper .ks-table-header:nth-of-type(2)', // Size By Breed
      '.kiwi-cross-table-header div', // SIZE (in breed table)
      '.ks-vertical-cell div', // Breed (left column)
      '.ks-table-cell', // Small, Medium, Large (only filter specific texts)
      '.ks-tab-header',
    ].join(', '),
    onTranslate: (element, before, after) => {
      // console.log(`Kiwi element translated: "${before}" → "${after}"`);
    }
  });

  // Initialize for store locator elements
  const storeLocatorTranslator = new ShopifyTranslator({
    language: currentLanguage,
    buttonSelector: 'button#storemapper-go, button#storemapper-filter-0, .storemapper-select-all > span, input#storemapper-zip, .storemapper_view .storemapper-storelink, .btn.storemapper-map-directions',
    onTranslate: (element, before, after) => {
      // console.log(`Store locator element translated: "${before}" → "${after}"`);
    }
  });

  // Initialize for misc. elements
  const miscTranslator = new ShopifyTranslator({
    language: currentLanguage,
    buttonSelector: '.low-stock-alert',
    onTranslate: (element, before, after) => {
      // console.log(`Store locator element translated: "${before}" → "${after}"`);
    }
  });

  // Initialize for size option elements
  const sizeOptionTranslator = new ShopifyTranslator({
    language: currentLanguage,
    buttonSelector: [
      'label.filter-group--custom__label > span',
      '.product-option__swatch--size',
      '.swatch__label .currently-selected-option-name'
    ].join(', '),
    onTranslate: (element, before, after) => {
      // console.log(`Store locator element translated: "${before}" → "${after}"`);
    }
  });

  // Initialize for size option elements
  const upsellTranslator = new ShopifyTranslator({
    language: currentLanguage,
    buttonSelector: [
      '.variants-wrapper select option',
      '.line-item .select-items > div',
      '.line-item .select-selected.custom-select__menu',
    ].join(', '),
    onTranslate: (element, before, after) => {
      // console.log(`Store locator element translated: "${before}" → "${after}"`);
    }
  });
  
  // Initialize for collection elements
  const collectionTranslator = new ShopifyTranslator({
    language: currentLanguage,
    buttonSelector: [
      'h2.collection-main__title span.content',
    ].join(', '),
    onTranslate: (element, before, after) => {
      console.log(`Store locator element translated: "${before}" → "${after}"`);
    }
  });

  // Add to window for debugging purposes
  window.shopifyTranslators = {
    main: mainTranslator,
    badge: badgeTranslator,
    yopto: yotpoTranslator,
    kiwi: kiwiTranslator,
    storeLocator: storeLocatorTranslator,
    misc: miscTranslator,
    sizeOption: sizeOptionTranslator,
    upsell: upsellTranslator,
    collection: collectionTranslator,
  };
});
